import React, { PureComponent } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, EffectCoverflow } from 'swiper'
import interviews from "./videos.json"

import 'swiper/swiper-bundle.css'
import './Interviews.scss'

SwiperCore.use([Navigation, EffectCoverflow])
export default class Interviews extends PureComponent {
  swiperRef = React.createRef()

  handleSlideChange = () => {
    const videos = document.querySelectorAll('.swiper-interviews video')
    videos.forEach(video => {
      video.pause()
    })
  }

  render() {
    return (
      <section className="swiper-interviews">
        <Swiper
          modules={[EffectCoverflow, Navigation]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView="auto"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
          }}
          navigation={true}
          onSlideChange={this.handleSlideChange}
          ref={this.swiperRef}
        >
          {interviews.map((interview, index) => (
            <SwiperSlide key={index}>
              <video controls disablePictureInPicture controlsList="nodownload">
                <source src={interview.video} type="video/mp4" />
              </video>

              <div>
                <strong>{ interview.name }</strong>
                <span>{ interview.job }</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    )
  }
}
